export default {"src":"/_next/static/media/logoMegaWhite.53b0677e.svg","height":52,"width":139,"blurWidth":0,"blurHeight":0};